import homepage from './homepage'
import personalHomepage from './personalHomepage'
import myClass from './myclass'
const student = {
  path: 'student',
  component: resolve => require(['../../../../components/pages/student_user/student'], resolve),
  redirect: 'student/myclass',
  children: [
    homepage,
    personalHomepage,
    myClass
  ]
}

export default student
